import React from "react";

export const MyPage = () => {
    return <div>MyPage</div>;
};
